/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function clearNaviBarRightItem(params) {
    // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431124.0.0
    var formatInput = function () { return ({
        text: '',
        imgUrl: '',
        callback: null,
    }); };
    WVCall('TitlebarModule.setFarRightButton', params, { formatInput: formatInput });
}

export { clearNaviBarRightItem as default };
